var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState, useCallback, useMemo } from 'react';
import { TextField } from '../TextField';
import { Container, Icon } from './elements';
import { PredictiveDropdown } from './PredictiveDropdown';
import { noop } from '../../util';
import { InternalProvider } from '../../util/InternalProvider';
// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-constraint
export var PredictiveTextField = React.forwardRef(function (_a, fRef) {
    var label = _a.label, fieldStatus = _a.fieldStatus, _b = _a.value, value = _b === void 0 ? '' : _b, _c = _a.suggestions, suggestions = _c === void 0 ? [] : _c, _d = _a.handleChange, handleChange = _d === void 0 ? noop : _d, iconSrc = _a.iconSrc, _e = _a.affixLeftClickable, affixLeftClickable = _e === void 0 ? false : _e, onSelection = _a.onSelection, className = _a.className, _f = _a.disableHighlight, disableHighlight = _f === void 0 ? false : _f, _g = _a.includeSubheader, includeSubheader = _g === void 0 ? true : _g, _h = _a.suggestWhenEmpty, suggestWhenEmpty = _h === void 0 ? false : _h, _j = _a.alertNoResults, alertNoResults = _j === void 0 ? true : _j, restProps = __rest(_a, ["label", "fieldStatus", "value", "suggestions", "handleChange", "iconSrc", "affixLeftClickable", "onSelection", "className", "disableHighlight", "includeSubheader", "suggestWhenEmpty", "alertNoResults"]);
    var _k = useState(false), focused = _k[0], setFocused = _k[1];
    var _l = useState(''), keyword = _l[0], setKeyword = _l[1];
    var _m = useState(-1), activeSuggestionIndex = _m[0], setActiveSuggestionIndex = _m[1];
    var onChange = useCallback(function (value) {
        handleChange(value);
        setFocused(true);
        !disableHighlight && setKeyword(value);
        setActiveSuggestionIndex(-1);
    }, []);
    var showSuggestions = useMemo(function () { return focused && (value.length > 0 || suggestWhenEmpty); }, [focused, value, suggestWhenEmpty]);
    var handleKeyDown = useCallback(function (e) {
        if (e.key === 'Enter') {
            if (activeSuggestionIndex === -1)
                return;
            e.preventDefault();
            setFocused(false);
            setActiveSuggestionIndex(-1);
            onSelection(suggestions[activeSuggestionIndex]);
        }
        else if (e.key === 'ArrowUp') {
            e.preventDefault();
            if (activeSuggestionIndex === -1)
                return;
            setActiveSuggestionIndex((activeSuggestionIndex + suggestions.length - 1) %
                suggestions.length);
        }
        else if (e.key === 'ArrowDown') {
            setActiveSuggestionIndex((activeSuggestionIndex + 1) % suggestions.length);
        }
        else if (e.key === 'Escape') {
            e.preventDefault();
            setFocused(false);
            setActiveSuggestionIndex(-1);
        }
    }, [activeSuggestionIndex]);
    return (React.createElement(InternalProvider, null,
        React.createElement(Container, { className: className, onFocus: function () { return setFocused(true); }, onBlur: function () {
                setFocused(false);
                setActiveSuggestionIndex(-1);
            } },
            React.createElement(TextField, __assign({}, restProps, { "data-testid": "model-predictive-text-input", autoComplete: "off", value: value, ref: fRef, fieldStatus: fieldStatus, onChange: function (_a) {
                    var target = _a.target;
                    return onChange(target.value);
                }, label: label, affixLeft: iconSrc && React.createElement(Icon, { src: iconSrc, size: 'large' }), affixLeftClickable: iconSrc && affixLeftClickable, affixRightClickable: true, affixRight: value.length > 0 && (React.createElement(Icon, { src: "CloseX", onMouseDown: function (event) { return event.preventDefault(); }, size: 'large', onClick: function () { return onChange(''); } })), onKeyDown: handleKeyDown })),
            showSuggestions && (React.createElement(PredictiveDropdown, { "data-testid": 'model-predictive-text-dropdown-container', onSelection: onSelection, keyword: keyword, fieldStatus: fieldStatus, setFocused: setFocused, suggestions: suggestions, includeSubheader: includeSubheader, alertNoResults: alertNoResults, activeSuggestionIndex: activeSuggestionIndex, setActiveSuggestionIndex: setActiveSuggestionIndex })))));
});
export default PredictiveTextField;
